// Structured rejection categories for booking-request submissions.
// Chosen at reject time alongside the always-required free-text note; the
// category drives chart breakdowns and keeps sensitive detail out of AI
// prompts, while the note carries the specifics for the team.
export const BOOKING_REJECTION_CATEGORIES = [
  { key: "background_check", label: "Background check" },
  { key: "income", label: "Income / affordability" },
  { key: "esa_pets", label: "ESA / pets" },
  { key: "incomplete", label: "Incomplete application" },
  { key: "occupancy", label: "No availability / timing" },
  { key: "other", label: "Other" },
] as const;

export type BookingRejectionCategoryKey = (typeof BOOKING_REJECTION_CATEGORIES)[number]["key"];

export const BOOKING_REJECTION_CATEGORY_KEYS: readonly BookingRejectionCategoryKey[] =
  BOOKING_REJECTION_CATEGORIES.map((c) => c.key);

export function isBookingRejectionCategory(value: unknown): value is BookingRejectionCategoryKey {
  return typeof value === "string" && (BOOKING_REJECTION_CATEGORY_KEYS as readonly string[]).includes(value);
}

export function bookingRejectionCategoryLabel(key: string | null | undefined): string | null {
  if (!key) return null;
  const found = BOOKING_REJECTION_CATEGORIES.find((c) => c.key === key);
  return found ? found.label : key;
}
